export default __webpack_public_path__ + "static/media/first-day-of-work.544acba1.jpg";